module.exports = __webpack_public_path__ + "img/605_1.e724c4a4.jpg";